import { find, keys } from 'lodash';
import translator from './translator';
export function generateKeys(obj) {
    for (const key of keys(obj)) {
        obj[key].key = key;
    }
    return obj;
}
export function generateLocalization(name, obj) {
    for (const key of keys(obj)) {
        let id = `enum.${name}.${key}`;
        if (obj[key].question) {
            id = obj[key].question;
        }
        const defaultMessage = (obj[key].labelWeb || obj[key].label);
        obj[key].localization = {
            id,
            defaultMessage,
            t: (locale, variables) => translator.getTranslation(locale, id, defaultMessage, variables),
        };
    }
    return obj;
}
export function findEnum(enums, value, field = 'value') {
    return find(enums, (o) => o[field] === value);
}
